import React ,{Fragment,useEffect,useContext, useState}from "react";

import { Box, Stack,} from "@mui/material";
import {  Typography, Button, Grid,Chip} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Mycontext } from "../../mycontext";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import StatVisit from "../../../shared/functions/statVisit";
import { useParams } from 'react-router-dom'; // URL'den id almak için
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import DiscountLabel from "../../../shared/components/discounlabel";
import { useMediaQuery } from "@mui/material";
import slugify from "slugify";
import { Helmet } from "react-helmet-async";

const apiUrl = process.env.REACT_APP_API_URL;

const  matot=['80x150 cm:  39€','100x200 cm :  69€','120x170 cm :  69€', '160x230 cm : 129€','200x290 cm : 199€']
const conditions = ["Hyvä", "Erinomainen", "Kuin Uusi", "Käyttämätön"];

function Product(props) {
  const { id, slug } = useParams();
  let productId;
  if (id) {
    // Eski URL: /products/:id
    productId = id;
  } else if (slug) {
    // Yeni SEO URL: /tuotteet/:slug
    productId = slug.split("-").pop(); 
  }
  console.log(productId)
  const [data, setData] = useState(null); // API'den gelecek veri
  const [alignment, setAlignment] = useState("Hyvä");
  const [price, SetPrice] = useState();
  const [size, SetSize] = useState();
  const [galleryImages, setGalleryImages]= useState([])
  const context = useContext(Mycontext);
  const { setCartItemsCount, cartItemsData, setCartItemsData } = context;
  const isMobile = useMediaQuery("(max-width:400px)");
  const [isFullscreen, setIsFullscreen] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/products/${productId}`); // API isteği
        const resultArray = await response.json(); // Sonucu JSON formatında alıyoruz, bu bir array içinde string olarak geliyor
        // İlk elemanı bir JSON string ise bunu parse etmemiz gerekiyor
        if (resultArray.length > 0) {
            const result = JSON.parse(resultArray[0]); // İlk elemanı parse ederek JSON nesnesine çeviriyoruz
            console.log(result); // Artık result normal bir JSON nesnesi
            setData(result); // Gelen veriyi state'e kaydediyoruz
            setAlignment(result.condition); // Ürünün durumunu set ediyoruz

        } else {
            console.error("Beklenmeyen veri formatı: API'den gelen sonuç boş.");
        }
       
      } catch (error) {
        console.error("Error fetching data:", error);
        
      }
    };
    fetchData();
    
  }, [productId]);

  useEffect(() => {
    
    if (data && data.imgs) {
      let images = data.imgs.split(',').map(el => apiUrl + "/images/" + el);
      setGalleryImages(
        images.map(image => ({
          original: image,
          thumbnail: image,
        }))
      );
    }
  }, [data]);

  if(!data == null){
    StatVisit(productId)
  }
  useEffect(() => {
    if (data && !price && data.dimensions.indexOf('|') > -1) {
      // Eğer localStorage'de daha önce bir fiyat set edilmişse onu alıyoruz
      if (window.localStorage.getItem('price' + data.id)) {
        let prc = window.localStorage.getItem('price' + data.id);
        SetPrice(prc);
        let sz = matot.filter(el => el.indexOf(prc) > -1)[0].split(':')[0];
        SetSize(sz.replaceAll(' ', '').replace('cm', ''));
      } else {
        SetPrice(getPriceFromSize(matot, data.dimensions.split('|')[0]));
      }

      // Sayfa yüklendiğinde en üstte scroll yapıyoruz
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 200); // 200ms gecikme ile kaydırma yapıyoruz
    }
  }, [data, price]);

  useEffect(() => {
    setCartItemsCount(cartItemsData.length);
  }, [cartItemsData]);

  if (!data || data.length <1) {
    return <div>Product not found</div>;
  }
  const getPriceFromSize = (matot, size) => {
    let sz=size.replaceAll(' ', '')
    let item = matot.filter(el => el.split(':')[0].replaceAll(' ', '').replace('cm','') === sz)
    if (item.length>0) {
      console.log(item)
      let prc= item[0].split(':')[1].replaceAll(' ', '')
      SetPrice(prc)
      SetSize(sz)
      localStorage.setItem('price'+data.id, prc);
      return prc;
    }
    return null;
  };


  let dimensions= []
  if(data){
  if(data.dimensions !== "")dimensions.push('Syveys / Leveys : ' + data.dimensions + 'cm')
  if(data.height !== "")dimensions.push('Korkeus/Height : ' +data.height+ ' cm')
  if(data.feetheight !== "")dimensions.push('Jalkojen korkeus/ Height of feet: ' + data.feetheight+ ' cm')
  if(data.seatwidth !== "")dimensions.push('Istuimenleveys / Seat width :' +  data.seatwidth + ' cm')
  if(data.beddimensions !== "")dimensions.push('Nukkumisleveys / Sleeping width : ' + data.beddimensions+ ' cm')
  if(data.rahidimensions !=="")dimensions.push('Rahin Mitat:' + data.rahidimensions+ 'cm')
  }
    
  function get_text(data, tx) {

     if (data.type === 'Matot' && tx==='h' )
      {
        return (
          
                <ListItemText
                    primary={<Typography variant='h4'>Hinta:data{price}</Typography>}
                    secondary={<>{matot.map(el => <Typography variant='body1' sx={{ml:'10%'}}> {el} </Typography>)}</>}
                  />
        )
      }
     else if(data.type !== 'Matot' && tx==='h')
     {

      if(data.sale.indexOf('%') > -1){
        return(
  
          <ListItemText
             primary={<><Stack direction={"row"} spacing={2} ><Typography variant='h4'>Hinta:</Typography> <DiscountLabel sale={data.sale}></DiscountLabel></Stack></>}
              secondary={'Ilmainen Kotin Kuljetus 24H Sisällä'}
            />
        )

      }
      else{
        return(
        <ListItemText
            primary={
              <Typography variant="h4">
                {data.status === "Sold"
                  ? "Myyty"
                  : data.status === "Reserved"
                  ? "Reserved"
                  : `Hinta: ${data.sale} €`}
              </Typography>
            }
              secondary={'Ilmainen Kotin Kuljetus 24H Sisällä'}
            />)
      }
    
     }


     else if (data.type === 'Matot' && tx==='m' )
      {
        return (
          
          <ListItemText
          primary={<Typography variant='h6'>Saatavilla:</Typography>}
          secondary={<>
            <Box  display="flex" justifyContent="center" flexWrap="wrap" gap={2}>
             {data.dimensions.split('|').map((el,index) =>
                <Button
                key={index}
                onClick={()=> getPriceFromSize(matot,el.replaceAll(' ', '')) }
                color='error'
                variant={el.replaceAll(' ', '') === size ? 'contained': 'outlined'}
              >
                {el.replaceAll(' ', '')}
              </Button>
             )}
            </Box>
            </>}
            />
        )
      }

      else if (data.type !== 'Matot' && tx==='m' )
        {
          return (
            <ListItemText
            primary={<Typography variant='h6'>Mität:</Typography>}
            secondary={<>{dimensions.map(el => <Typography variant='body2' sx={{ml:'10%'}}> {el} </Typography>)}</>}
              />
          )
        }
  }
  
  const addChart = (productId) => {
    const dt = JSON.parse(JSON.stringify(data));
    if(price){
      dt.sale=price.replaceAll('€','')
      dt.name= data.name + size
    }
    
    if (cartItemsData.filter(el => JSON.stringify(el )  === JSON.stringify(dt)).length == 0)
      { 
        let updtdata= [...cartItemsData, dt]
        setCartItemsData(updtdata)
        setCartItemsCount(updtdata.length)
        window.localStorage.setItem('chart',JSON.stringify(updtdata))
      }
      console.log(cartItemsData)
  };

  const safeType = data?.type || '';
  const safeName = data?.productName || '';
  return (
    <Fragment>
        <Helmet>
          <title>{safeName} | Ehankki</title>
          <link
            rel="canonical"
            href={`https://ehankki.fi/tuotteet/${slugify(safeType)}/${slugify(safeName)}-${data?.id}`}
          />
          <meta
            name="description"
            content={data?.descriptions?.[0]?.text?.replace(/<[^>]+>/g, '').slice(0, 160) || 'Tutustu tuotteisiimme'}
          />
          <meta property="og:title" content={safeName} />
          <meta
            property="og:description"
            content={data?.descriptions?.[0]?.text?.replace(/<[^>]+>/g, '').slice(0, 160)}
          />
          <meta
            property="og:image"
            content={`https://ehankki.fi/images/${data?.images?.[0]}`}
          />
          <link
            rel="canonical"
            href={`https://ehankki.fi/tuotteet/${slugify(safeType)}/${slugify(safeName)}-${data?.id}`}
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "Product",
              name: data?.productName || "Nimetön Tuote",
              image: data?.images?.map(id => `${apiUrl}/images/${id}.jpg`) || [],
              description: data?.descriptions?.[0]?.text?.replace(/<[^>]*>?/gm, '') || '',
              sku: String(data?.id || ""),
              brand: {
                "@type": "Brand",
                name: "ComfyGO"
              },
              offers: {
                "@type": "Offer",
                priceCurrency: "EUR",
                price: price || 0,
                priceValidUntil: "2025-12-31",
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/InStock",
                url: `https://ehankki.fi/tuotteet/${slugify(data?.productName || "")}-${data?.id || ""}`
              },
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "4.7",
                reviewCount: "12"
              },
              review: [
                {
                  "@type": "Review",
                  author: "Asiakas",
                  datePublished: "2024-03-15",
                  reviewBody: "Hyvä laatu ja nopea toimitus!",
                  reviewRating: {
                    "@type": "Rating",
                    ratingValue: "5"
                  }
                }
              ]
            })}
          </script>
        </Helmet>
     <Box sx={{ justifyContent: 'center',  width:{xs:'100%', md:'70%', lg:'60%'},ml:{xs:'0%',md:'15%',lg:'20%'},mt:{md:'12vh',xs:'3vh'}}}>
         <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component='h1' variant="h4">{data.name}</Typography>
            </Grid>
            <Grid item xs={12} md={8}  alignItems='center'>
            <ImageGallery
              showNav={isFullscreen}
              items={galleryImages}
              showPlayButton={false}
              onScreenChange={(fullscreen) => setIsFullscreen(fullscreen)}
              renderItem={(item) => (
                <div className="image-gallery-image">
                  <img
                    src={item.original}
                    alt={data.name}
                    srcSet={item.srcSet}
                    title={item.originalTitle}
                    style={{
                      width:isMobile? '100%':'95%',
                      height: isFullscreen ? "90vh" : isMobile? '36vh':'55vh', 
                      objectFit: "contain", // Resmin orijinal oranını koruyarak sığdırır
                      backgroundColor: "#f0f0f0" // Boşluk varsa daha estetik görünmesi için arka plan rengi ekleyelim
                    }}
                  />
                </div>
              )}
              renderThumbInner={(item) => (
                <img
                  src={item.thumbnail}
                  alt={data.name}
                  title={item.originalTitle}
                  style={{ height: "6vh" }}
                />
              )}
            />
            </Grid>
            <Grid item xs={8} md={4} sx={{display:{xs:'block', md:'none'}}}>
            <List >
                <ListItem>
                {get_text(data,'h')}
                </ListItem>   
            </List>
            </Grid>

            <Grid item xs={12} md={4}>
            <List >
                <ListItem sx={{display:{xs:'none', md:'block'}}}>
                   {(data.status =='Sold')?<Typography variant='h4' color='error'>Myyty </Typography>: get_text(data,'h')}
                </ListItem>
                <ListItem >
                <ListItemText
                    primary={<Typography variant='h6'>Väri:</Typography>}
                    secondary={<><Typography variant='body1' sx={{ml:'10%'}}> { data.color}    </Typography></>}
                  />
                </ListItem>

                <ListItem >
                   {get_text(data,'m')}
                </ListItem>
                
            </List>
            <Box display='flex' justifyContent='center'>
            <Button
                  disabled={data.status==='Sold'? true: data.status === 'Reserved'?true:false}
                  variant="contained"
                  color='error'
                  sx={{borderRadius:'50', mt:'2%',width:'70%'}}
                  startIcon={<AddShoppingCartIcon></AddShoppingCartIcon>}
                  onClick={()=> addChart(data.id)}
                >
                Lisää ostoskoriin
              </Button>
             </Box> 
            <Box display='flex' justifyContent='center'>
              <Button
                  variant="contained"
                  color='success'
                  sx={{borderRadius:'50', mt:'4%', width:'70%'}}
                  startIcon={<WhatsAppIcon />}
                  href={`https://wa.me/+358413124969?text=${encodeURIComponent( 'https://ehankki.fi/products/'+data.id)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Nopeasti Yhteyttä 
              </Button>
            </Box>
             <Box display='flex' justifyContent='center' mt='2vh'>
              <img src={`${process.env.PUBLIC_URL}/klarna.png`} style={{ width: '70%' }} alt="klarna" />
            </Box> 
            </Grid>
            <Grid item xs={12}>
            <Stack 
              direction="row" 
              flexWrap="wrap" 
              spacing={1} 
              sx={{
                mt:'2%',
                justifyContent: isMobile ? "center" : "flex-start", // Mobilde ortala
                gap: isMobile ? 0.5 : 1, // Küçük ekranda daha az boşluk
              }}
            >
              {conditions.map((condition) => (
                <Chip
                  key={condition}
                  label={condition}
                  color={alignment === condition ? "warning" : "default"}
                  sx={{
                    fontSize: isMobile ? "0.6rem" : "1.1rem", 
                    padding: isMobile ? "4px" : "12px",
                    borderRadius: "20px", // Yuvarlak görünüm
                  }}
                />
              ))}
            </Stack>
            </Grid>
            <Grid item xs={12}>
            <List >
                <ListItem>
                <ListItemText
                    primary={<Typography variant='h6'>Lisä Tietoa:</Typography>}
                    secondary={data.mark.split('|').map(el =>
                      <Typography variant='body1' sx={{ml:'10%'}}> {el} </Typography>
                    )}
                  />
                </ListItem>      
            </List>
            { data.condition !== 'Käyttämätön' && <List >
                <ListItem>
                <ListItemText
                  primary={
                    <>
                      <Typography variant="h6" component="h1">
                        Käytetty sohva, laadukkaat käytetyt huonekalut – kaikki huolellisesti puhdistettu ja desinfioitu
                        ammattimaisilla koneilla. Tuemme kierrätystä ja tarjoamme edullisia sisustusratkaisuja kotitalouksille.
                      </Typography>
                      <Typography variant="h6">
                        Toimitus samana tai seuraavana päivänä (nopein toimitus)
                      </Typography>
                    </>
                  }
                />
                </ListItem>      
            </List>}
            </Grid>
          </Grid>

      </Box>
    </Fragment>
  );
}
Product.propTypes = {
};

export default Product;
